import { create } from 'zustand';
import { collectionsApi, dropsApi } from '@/lib/api';
import { InventorySingleDrop } from '@/types/singleDrop';
import { InventoryCollection } from '@/types/collection';

interface InventoryStoreMethods {
  fetchInventorySingleDrops(): Promise<InventorySingleDrop[]>;
  fetchInventoryCollections(): Promise<any>;
  cleanInventoryState(): void;
}

type InventoryState = InventoryStoreMethods & {
  drops: InventorySingleDrop[];
  collections: InventoryCollection[];
};

export const useInventoryStore = create<InventoryState>()((set) => ({
  drops: [],
  collections: [],
  cleanInventoryState: () => {
    set({ drops: [], collections: [] });
  },
  fetchInventorySingleDrops: async () => {
    const drops = await dropsApi.getInventorySingleDrops();
    set({ drops });
    return drops;
  },
  fetchInventoryCollections: async () => {
    const collections = await collectionsApi.getInventoryCollections();
    set({ collections });
    return collections;
  },
}));
